import {
    Button, Input, Modal, ModalBody, ModalHeader, Select, SelectOption,
} from 'appkit-react';
import { Col, Row } from 'react-bootstrap';

const DataLengthCheckModal = ({
    isDataLengthCheckModalvisible, onSaveDataLengthCheckDetails, columnName, operators, operator, setOperator, value1, setValue1, value2, setValue2, disableSaveBtn, onCancel,
}) => (
    <>
        <Modal
            className="action-modal-showcase"
            visible={isDataLengthCheckModalvisible}
            onCancel={() => onCancel()}
            style={{ width: '600px' }}
            backdropClosable={false}
        >
            <ModalHeader>
                <div className="a-modal-example-header">
                    <div className="modal-title-left">
                        <div className="modal-title">{`${columnName} : Data Length Check Details`}</div>
                    </div>
                </div>
            </ModalHeader>
            <ModalBody>
                <Row>
                    <Col md={5}>
                        <div className="a-h6" style={{ marginBottom: '0.2rem' }}>Operator </div>
                        <Select
                            onSelect={e => { setOperator(e); }}
                            value={operator}
                            name="operator"
                        >
                            {
                                operators.map(({ id, name, value }) => <SelectOption key={id} value={value}>{name}</SelectOption>)
                            }
                        </Select>
                    </Col>
                    <Col style={{ paddingLeft: 0 }}>
                        <div className="a-h6" style={{ marginBottom: '0.2rem' }}>
                            {
                                operator === 'between' ? 'Range1' : 'Value'
                            }
                        </div>
                        <Input
                            type="number"
                            name="value1"
                            value={value1}
                            onChange={e => {
                                setValue1(e);
                            }}
                        />

                    </Col>
                    <Col style={{ paddingLeft: 0 }}>
                        {operator === 'between'
                            && (
                                <>
                                    <div className="a-h6" style={{ marginBottom: '0.2rem' }}>Range2 </div>
                                    <Input
                                        type="number"
                                        name="value2"
                                        value={value2}
                                        onChange={e => {
                                            setValue2(e);
                                        }}
                                    />
                                </>
                            )}
                    </Col>
                </Row>

                <div className="button-comp">
                    <Button kind="secondary" gray onClick={() => { onCancel(); }} size="lg"> Cancel </Button>
                    <Button kind="primary" onClick={onSaveDataLengthCheckDetails} size="lg" disabled={disableSaveBtn}> Save </Button>
                </div>
            </ModalBody>
        </Modal>
    </>
);

export default DataLengthCheckModal;
